import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Select2 from "../../../../components/common/select/Select2";
import Input from "../../../../components/common/input/Input";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import { Field } from "redux-form";
import { required, numeric } from "../../../../utils/forms/validators";
import styles from "./Box.scss";

const years = numeric("Please enter whole years only.");

class Box extends Component {
  constructor(props) {
    super(props);
    this.state = {
      firstCol: props.showYearsWorked ? 5 : 6,
      secondCol: props.showYearsWorked ? 4 : 6
    };
  }

  render() {
    return (
      <Row className={styles.box}>
        <Col xs={12} md={this.state.firstCol} className={styles.boxPadding}>
          {this.props.typeahead ? (
            <Field
              allowNew={this.props.allowNew}
              component={Typeahead}
              isAsync={true}
              isLoading={this.props.isLoading}
              labelKey={this.props.labelKey}
              minLength={3}
              name={this.props.name}
              newSelectionPrefix={this.props.prefix}
              paginationText={`Display additional ${this.props.name}...`}
              placeholder={this.props.placeholderTypeahead}
              options={this.props.options}
              selected={this.props.selected}
              validate={[required]}
              valueKey={this.props.valueKey}
              focusOut={(query, selected) => {
                if (this.props.focusOut) {
                  this.props.focusOut(query, selected, this.props.name);
                }
              }}
              onSearch={query => {
                this.props.onSearch(query);
                if (this.props.change && this.props.inputCompanyName) {
                  this.props.change(this.props.inputCompanyName, query);
                }
              }}
            />
          ) : (
            <Field
              component={Select2}
              isLoading={this.props.isLoading}
              name={this.props.name}
              placeholder={this.props.title}
              options={this.props.options}
              validate={[required]}
            />
          )}
        </Col>

        <Col xs={12} md={this.state.secondCol} className={styles.boxPadding}>
          <Field
            component={Input}
            name={this.props.inputName}
            placeholder={this.props.placeholder}
            type="text"
            validate={[required]}
          />
        </Col>

        {this.props.showYearsWorked && (
          <Col xs={12} md={3} className={styles.boxPadding}>
            <Field
              component={Input}
              name={this.props.inputNameExtra}
              placeholder="# of Years"
              type="text"
              validate={[required, years]}
            />
          </Col>
        )}
      </Row>
    );
  }
}

export default Box;



// WEBPACK FOOTER //
// ./src/routes/candidate/completeProfile/components/Box.js